// PRD-0014 Phase 3 — pending workflow human gates

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { HumanGate } from "../../../shared/types";

export function useHumanGatesPending(enabled = true) {
  return useQuery({
    queryKey: ["human-gates", "pending"],
    queryFn: () => api.get<{ data: HumanGate[] }>("/api/human-gates/pending"),
    enabled,
  });
}

export function useHumanGateAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: {
      gateId: string;
      action: "approve" | "reject" | "changes";
      comment?: string;
      /** Stable per modal session — enables server-side idempotent replay (issue #64). */
      idempotencyKey?: string;
    }) => {
      const headers: Record<string, string> = {};
      if (body.idempotencyKey) {
        headers["Idempotency-Key"] = body.idempotencyKey;
      }
      return api.post<{
        data: { instanceId: string; status: string; currentNodeId: string | null };
      }>(
        `/api/human-gates/${encodeURIComponent(body.gateId)}/action`,
        {
          action: body.action,
          comment: body.comment ?? "",
        },
        headers,
      );
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["human-gates"] });
      qc.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}
